import { useCallback } from "react";
import useApiClient from "../services/axiosInstance";

export const useFinancialSnapshot = () => {
  const { api } = useApiClient();

  const saveFinancialSnapshot = useCallback(
    async (data) => {

      try {
        const response = await api.post("/api/financial-accounts/save", data);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    [api]
  );
  const getFinancialSnapshot = useCallback(
    async (data) => {
      try {
        const response = await api.post("/api/financial-accounts/fetch", data);
        return await response.data;
      } catch (error) {
        throw error;
      }
    },
    [api]
  );
  return { saveFinancialSnapshot, getFinancialSnapshot };
};
